import {getAxiosInstance, rethrowErrorWithMessage} from '../helpers/axios-helper'
import { DeleteError } from '../errors/DeleteError'

const baseUrl = process.env.BACKEND_URL

function getTenants () {
  return getAxiosInstance().get(`${baseUrl}/tenants`)
    .then(tenants => {
      return tenants.data
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function getTenantById(tenantId) {
  return getAxiosInstance().get(`${baseUrl}/tenants/${tenantId}`)
      .then(teamsResult => {
        return teamsResult.data
      })
      .catch(err => {
        console.error(err)
        throw err
      })
}

function addNewTenant (tenant, photo) {
  return getAxiosInstance().post(`${baseUrl}/tenants`, {
    tenant: tenant,
    photo: photo,
  }).catch(err => {
    rethrowErrorWithMessage(err)
  })
}

function updateTenant (tenantId, tenant) {
  return getAxiosInstance().put(`${baseUrl}/tenants/${tenantId}`, {
    tenant: tenant,
  }).catch(err => {
    rethrowErrorWithMessage(err)
  })
}

function deleteTenant (tenantId) {
  return getAxiosInstance().delete(`${baseUrl}/tenants/${tenantId}`)
    .then((data) => data)
    .catch(err => {
      if (err.response.data.code === 403) {
        throw new DeleteError(JSON.parse(err.response.data.message).names)
      }
      throw new Error(err.response.data.message)
    })
}

export default {
  getTenantById,
  getTenants,
  addNewTenant,
  updateTenant,
  deleteTenant
}
